import { render, staticRenderFns } from "./AverageGrades.vue?vue&type=template&id=59951fd4"
import script from "./AverageGrades.vue?vue&type=script&lang=js"
export * from "./AverageGrades.vue?vue&type=script&lang=js"
import style0 from "./AverageGrades.vue?vue&type=style&index=0&id=59951fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports